import { render, staticRenderFns } from "./AssessmentMode.vue?vue&type=template&id=cfadca74&scoped=true"
import script from "./AssessmentMode.vue?vue&type=script&lang=js"
export * from "./AssessmentMode.vue?vue&type=script&lang=js"
import style0 from "./AssessmentMode.vue?vue&type=style&index=0&id=cfadca74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfadca74",
  null
  
)

export default component.exports